import http from "../http-common";

class MyContentService {
  getNews(userId: string) {
    let url = `/my-content/news?userId=${userId}`;

    return http.get(url);
  }

  getBooks(userId: string) {
    let url = `/my-content/books?userId=${userId}`;

    return http.get(url);
  }

  getEvents(userId: string) {
    let url = `/my-content/events?userId=${userId}`;

    return http.get(url);
  }

  getLearning(userId: string) {
    let url = `/my-content/learning?userId=${userId}`;

    return http.get(url);
  }

  getTaxonomies() {
    let url = `/my-content/taxonomies`;

    return http.get(url);
  }
}

export default MyContentService;
